<ng-container *ngIf="!isButton">
  <button
    mat-icon-button
    (click)="showOptions()"
    [matBadge]="selectedItemsCount"
    [matBadgeHidden]="!showCountBadge"
    [disabled]="disabled"
    matBadgeOverlap="true"
    matBadgeSize="medium"
    #optionsPanelOrigin
  >
    <ts-icon [icon]="icon.name"></ts-icon>
  </button>
</ng-container>

<ng-container *ngIf="isButton">
  <ts-button
    [debounceTime]="0"
    type="stroked"
    color="accent"
    (click)="showOptions()"
    #optionsPanelOrigin
    [attr.data-testid]="'column-selector-button'"
  >
    <ts-icon icon="visibility" class="mr-2"></ts-icon>
    Fields
    <ng-container *ngIf="showCountBadge">
      <ts-badge [value]="selectedItemsCount" [type]="'info'"></ts-badge>
    </ng-container>
  </ts-button>
</ng-container>

<ng-template #optionsPanel>
  <div class="container" [class.medium]="size === 'medium'">
    <div class="container__header">
      <div class="container__header__filter">
        <mat-icon svgIcon="search"></mat-icon>
        <input
          type="text"
          placeholder="Enter field name"
          [(ngModel)]="filterText"
          [attr.data-testid]="'column-selector-field-input'"
        />
      </div>
    </div>
    <div
      class="container__items"
      cdkDropList
      [cdkDropListData]="items"
      (cdkDropListDropped)="dropped($event)"
      cdkDropListOrientation="vertical"
    >
      <div
        class="container__items__item"
        cdkDrag
        cdkDragLockAxis="y"
        *ngFor="let item of items | filterBy: ['label'] : filterText"
      >
        <mat-icon
          [class.visibility-hidden]="!(draggable && item.selected)"
          class="drag-handler"
          svgIcon="drag_indicator"
          matTooltip="Drag me"
          cdkDragHandle
        >
        </mat-icon>
        <mat-checkbox
          color="primary"
          [checked]="item.selected"
          (change)="checked(item)"
          [attr.data-testid]="getDataTestId(item.name)"
        >
          {{ item.label }}
        </mat-checkbox>
      </div>
    </div>
    <button
      mat-flat-button
      color="primary"
      (click)="save()"
      [disabled]="!canSave"
      [attr.data-testid]="'column-selector-apply-button'"
    >
      Apply
    </button>
  </div>
</ng-template>
